import React, { useState } from "react"
import { graphql } from "gatsby"
import "../assets/reset.css"
import styles from "./index.module.css"
import Toc from "../components/toc"
import SEO from "../components/seo"

const IndexPage = ({ data }) => {
  const { markdownRemark } = data
  const { html } = markdownRemark
  const [state, setDrawer] = useState(false)

  return (
    <>
      <SEO title="memo"></SEO>
      <div className={styles.container}>
        <div
          className={styles.contents}
          dangerouslySetInnerHTML={{ __html: html }}
        />
        {!state && (
          <div
            className={styles.trigger}
            onClick={() => {
              setDrawer(true)
            }}
          >
            |
          </div>
        )}
        <Toc isOpen={state} setDrawer={setDrawer}></Toc>
      </div>
    </>
  )
}

export const pageQuery = graphql`
  query {
    markdownRemark {
      html
    }
  }
`

export default IndexPage
